import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import TableContainer from 'Common/TableContainer';
import Select from 'react-select';

// Icons
import { Search, Trash2, Plus, MoreHorizontal, FileEdit, TimerReset } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

// Images

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  onGetProjectList, onAddProject, onUpdateProject, onDeleteProject,
  doLoginRoute
} from 'slices/thunk';
import { ToastContainer, toast } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import { doChangeProject } from '../../services/auth.service';
import { doGenerateResetPasswordLink } from '../../services/user.service';

const Project = () => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()

  const selectDataList = createSelector(
    (state: any) => state.Projects,
    (project) => ({
      projectList: project.projectList
    })
  );

  const { projectList } = useSelector(selectDataList);
  const [project, setProject] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // Get Data
  useEffect(() => {
    dispatch(onGetProjectList());
  }, [dispatch]);

  useEffect(() => {
    setProject(projectList);
  }, [projectList]);

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.projectId) {
      setEventData(cell);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteProject(eventData.projectId));
      setDeleteModal(false);
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  const handleClickResetPassword = async (userId: string) => {
    const shortUrl = await doGenerateResetPasswordLink(userId)
    if (!shortUrl) return

    navigator.clipboard.writeText(`${window.location.origin}/${shortUrl.code}`)
    toast.success('Link copied to clipboard', { autoClose: 2000 })
  }

  const handleClickAccess = (project: any) => {
    doChangeProject(project.projectId).then((res: any) => {
      doLoginRoute(navigate)
      window.location.reload()
    }).catch((error) => {
      console.log(error);
    })
  }

  const countrySelect = [
    { value: 'ID', label: 'Indonesia' },
  ];

  const currencySelect = [
    { value: 'IDR', label: 'Rupiah' },
  ];

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      projectId: (eventData && eventData.projectId) || '',
      name: (eventData && eventData.name) || '',
      description: (eventData && eventData.description) || '',
      sector: (eventData && eventData.sector) || '',
      address: (eventData && eventData.address) || '',
      email: (eventData && eventData.email) || '',
      contactPerson: (eventData && eventData.contactPerson) || '',
      contactNo: (eventData && eventData.contactNo) || '',
      code: (eventData && eventData.code) || '',
      country: (eventData && eventData.country) || '',
      currency: (eventData && eventData.currency) || '',
      isTest: (eventData && eventData.isTest) || false,
    },
    validationSchema: Yup.object({
      projectId: Yup.string().optional(),
      name: Yup.string().required("Please Enter Name"),
      description: Yup.string().optional(),
      sector: Yup.string().required("Please Enter Sector"),
      address: Yup.string().optional(),
      email: Yup.string().optional(),
      contactPerson: Yup.string().required("Please Enter Contact Person"),
      contactNo: Yup.string().required("Please Enter Contact No"),
      code: Yup.string().required("Please Enter Code"),
      country: Yup.string().required("Please Enter Country"),
      currency: Yup.string().required("Please Enter Currency"),
      isTest: Yup.boolean().default(false),
    }),

    onSubmit: (values) => {
      const data = {
        ...values,
      };
      if (isEdit) {
        // update user
        dispatch(onUpdateProject(data));
      } else {
        delete data.projectId;
        dispatch(onAddProject(data));
      }
      toggle();
    },
  });

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['name', 'code', 'country', 'sector', 'contactPerson', 'contactNo'];
    filterDataBySearch(projectList, search, keysToSearch, setProject);
  };

  const columns = useMemo(() => [
    {
      header: (
        <div className="flex items-center h-full">
          <input id="CheckboxAll" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
        </div>
      ),
      enableSorting: false,
      id: "checkAll",
      cell: (cell: any) => {
        return (
          <div className="flex items-center h-full">
            <input id="Checkbox1" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
          </div>
        );
      }
    },
    {
      header: "Name",
      accessorKey: "name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">
            <h6 className="mb-1">{cell.getValue()}</h6>
          </div>
        </div>
      ),
    },
    {
      header: "Code",
      accessorKey: "code",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">
            <h6 className="mb-1">{cell.getValue()}</h6>
          </div>
        </div>
      ),
    },
    {
      header: "Sector",
      accessorKey: "sector",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">{cell.getValue()}</div>
        </div>
      ),
    },
    {
      header: "Contact Info",
      accessorKey: "contactPerson",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">
            <h6 className="mb-1">{cell.getValue()}</h6>
            <p className="text-slate-500 dark:text-zink-200">{cell.row.original.contactNo}</p>
            <p className="text-slate-500 dark:text-zink-200">{cell.row.original.email}</p>
          </div>
          {
            cell.row.original.userId &&
            <Link to="#" onClick={() => {
              handleClickResetPassword(cell.row.original.userId)
            }} className="flex items-center justify-center w-[37.5px] h-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20">
              <TimerReset className="w-4 h-4"></TimerReset>
            </Link>
          }
        </div>
      ),
    },
    {
      header: "Country",
      accessorKey: "country",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">{cell.getValue()}</div>
        </div>
      ),
    },
    {
      header: "Test",
      accessorKey: "isTest",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">{cell.row.original.isTest.toString()}</div>
        </div>
      ),
    },
    {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Dropdown className="relative">
          <Dropdown.Trigger className="flex items-center justify-center w-[30px] h-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20" id={cell.row.original.userId}>
            <MoreHorizontal className="w-3 h-3" />
          </Dropdown.Trigger>
          <Dropdown.Content placement="right-end" className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600" aria-labelledby={cell.row.original.productCategoryId}>
            <li>
              <Link data-modal-target="addUserModal" className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!"
                onClick={() => {
                  const data = cell.row.original;
                  handleUpdateDataClick(data);
                }}>
                <FileEdit className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Edit</span></Link>
            </li>
            <li>
              <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}><Trash2 className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Delete</span></Link>
            </li>
            {
              cell.row.original.userId &&
              <li>
                <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                  const data = cell.row.original;
                  handleClickAccess(data);
                }}><Trash2 className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Access</span></Link>
              </li>
            }

          </Dropdown.Content>
        </Dropdown>
      ),
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], []
  );

  return (
    <React.Fragment>
      <BreadCrumb title='List View' pageTitle='Projects' />
      <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="projectsTable">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Projects List</h6>
                <div className="shrink-0">
                  <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block w-4 h-4" /> <span className="align-middle">Add Project</span></button>
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for name, email, phone number etc..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
                    <Search className="inline-block w-4 h-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              {project && project.length > 0 ?
                <TableContainer
                  isPagination={true}
                  columns={(columns || [])}
                  data={(project || [])}
                  customPageSize={10}
                  divclassName="-mx-5 -mb-5 overflow-x-auto"
                  tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                  theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                  PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                />
                :
                (<div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="w-6 h-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ projects We did not find any projects for your search.</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>


      {/* User Modal  */}
      <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">{!!isEdit ? "Edit Category" : "Add Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form action="#!" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
            <div className="mb-3">
              <label htmlFor="nameInput" className="inline-block mb-2 text-base font-medium">Name</label>
              <input type="text" id="nameInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Name"
                name="name"
                onChange={validation.handleChange}
                value={validation.values.name || ""}
              />
              {validation.touched.name && validation.errors.name ? (
                <p className="text-red-400">{validation.errors.name}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="codeInput" className="inline-block mb-2 text-base font-medium">Code</label>
              <input type="text" id="codeInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Code"
                name="code"
                onChange={validation.handleChange}
                value={validation.values.code || ""}
              />
              {validation.touched.code && validation.errors.code ? (
                <p className="text-red-400">{validation.errors.code}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="descriptionInput" className="inline-block mb-2 text-base font-medium">Description</label>
              <input type="text" id="descriptionInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Description"
                name="description"
                onChange={validation.handleChange}
                value={validation.values.description || ""}
              />
              {validation.touched.description && validation.errors.description ? (
                <p className="text-red-400">{validation.errors.description}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="sectorInput" className="inline-block mb-2 text-base font-medium">Sector</label>
              <input type="text" id="sectorInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Sector"
                name="sector"
                onChange={validation.handleChange}
                value={validation.values.sector || ""}
              />
              {validation.touched.sector && validation.errors.sector ? (
                <p className="text-red-400">{validation.errors.sector}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="addressInput" className="inline-block mb-2 text-base font-medium">Address</label>
              <input type="text" id="addressInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Address"
                name="address"
                onChange={validation.handleChange}
                value={validation.values.address || ""}
              />
              {validation.touched.address && validation.errors.address ? (
                <p className="text-red-400">{validation.errors.address}</p>
              ) : null}
            </div>
            {
              !isEdit &&
              <div className="mb-3">
                <label htmlFor="emailInput" className="inline-block mb-2 text-base font-medium">Email</label>
                <input type="text" id="emailInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter Email"
                  name="email"
                  onChange={validation.handleChange}
                  value={validation.values.email || ""}
                />
                {validation.touched.email && validation.errors.email ? (
                  <p className="text-red-400">{validation.errors.email}</p>
                ) : null}
              </div>
            }
            <div className="mb-3">
              <label htmlFor="contactPersonInput" className="inline-block mb-2 text-base font-medium">Contact Person Name</label>
              <input type="text" id="contactPersonInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Name"
                name="contactPerson"
                onChange={validation.handleChange}
                value={validation.values.contactPerson || ""}
              />
              {validation.touched.contactPerson && validation.errors.contactPerson ? (
                <p className="text-red-400">{validation.errors.contactPerson}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="contactNoInput" className="inline-block mb-2 text-base font-medium">Contact Phone Number</label>
              <input type="text" id="contactNoInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Number"
                name="contactNo"
                onChange={validation.handleChange}
                value={validation.values.contactNo || ""}
              />
              {validation.touched.contactNo && validation.errors.contactNo ? (
                <p className="text-red-400">{validation.errors.contactNo}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="countryInput" className="inline-block mb-2 text-base font-medium">Country</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={countrySelect}
                isSearchable={false}
                name="country"
                id="countryInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`country`, selectedOption?.value)
                }}
                value={countrySelect.find(country => { return country.value === validation.values.country })}
              />
              {validation.touched.country && validation.errors.country ? (
                <p className="text-red-400">{validation.errors.country}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="currencyInput" className="inline-block mb-2 text-base font-medium">Currency</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={currencySelect}
                isSearchable={false}
                name="currency"
                id="currencyInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`currency`, selectedOption?.value)
                }}
                value={currencySelect.find(currency => { return currency.value === validation.values.currency })}
              />
              {validation.touched.currency && validation.errors.currency ? (
                <p className="text-red-400">{validation.errors.currency}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="isTestInput" className="inline-block mb-2 text-base font-medium">Test?</label>
              <input type="checkbox" id="isTestInput" className="ml-4 w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer"
                name="isTest"
                onChange={validation.handleChange}
                defaultChecked={validation.values.isTest || true}
              />
              {validation.touched.isTest && validation.errors.isTest ? (
                <p className="text-red-400">{validation.errors.isTest}</p>
              ) : null}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={toggle}>Cancel</button>
              <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                {!!isEdit ? "Update Project" : "Add Project"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Project;
